import api from 'api';

import { defaultPagination } from './general';

type GetVehiclesType = {id: number | string}

export const listVehicleTypes = async (params) => api().get('/vehicle_types', { params: { ...defaultPagination, ...params } });

export const listVehicles = async (params) => api().get('/vehicles', { params: { ...defaultPagination, ...params } });

export const getVehicles = async ({ id }:GetVehiclesType) => api().get(`/vehicles/${id}`);

export const createVehicles = async ({ data }) => api().post('/vehicles', {
  ...data,
  vehicleUrls: data.vehicleUrls?.filter((url) => !!url && !url.empty),
});

export const updateVehicles = async ({ id, data }) => api().put(`/vehicles/${id}`, {
  ...data,
  vehicleUrls: data.vehicleUrls?.filter((url) => !!url && !url.empty),
});
